import styled from 'styled-components';
import { Paper, theme, FormFieldInput, Button, minBp } from '@triumph/shared';

export const Wrap = styled(Paper)`
  padding: 30px 20px;
  margin-bottom: 24px;
  position: relative;

  @media ${minBp('desktop')} {
    padding: 43px 62px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 11px;
  font-size: 20px;
  line-height: 24px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 22px;
    line-height: 30px;
    margin: 0 0 8px;
  }
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin-bottom: 27px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    padding-bottom: 30px;
    margin-bottom: 40px;
  }
`;

export const EditButton = styled.button`
  appearance: none;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  color: ${theme.colors.primary};
  font-size: 16px;
  font-family: inherit;
  text-transform: uppercase;
  position: absolute;
  top: 30px;
  right: 20px;

  @media ${minBp('desktop')} {
    top: 43px;
    right: 62px;
  }
`;

export const PostCodeLookupWrap = styled.div`
  margin: 0 0 20px;

  @media ${minBp('desktop')} {
    margin-bottom: 35px;
  }
`;

export const LocationLookup = styled.div`
  @media ${minBp('tablet')} {
    display: flex;
    align-items: center;
  }
`;


export const PostCodeInput = styled(FormFieldInput)`
  flex: 1;
  width: 100%;
  margin-right: 10px;
  height: 48px;

  @media ${minBp('tablet')} {
    margin-right: 18px;
    min-width: 280px;
    max-width: 280px;
  }

  @media ${minBp('desktop')} {
    height: 48px;
  }
`;

export const PostCodeSearchWrap = styled.div`
  @media ${minBp('tablet')} {
    display: flex;
  }
`;

export const Or = styled.div`
  font-size: 17px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  color: #000;
  padding: 9px 0;
  text-align: center;

  @media ${minBp('tablet')} {
    padding: 0 18px;
    text-align: left;
  }
`;

export const LocationButton = styled(Button)`
  width: 100%;

  svg {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
    margin-right: 12px;
  }

  @media ${minBp('tablet')} {
    width: auto;
  }
`;

export const SearchButton = styled(Button)`
  margin-top: 18px;
  width: 100%;

  @media ${minBp('tablet')} {
    margin: 0;
    width: auto;
  }

  @media ${minBp('desktop')} {
    padding-left: 18px;
    padding-right: 18px;
  }
`;

export const MapResultsWrap = styled.div`
  margin-bottom: 20px;

  @media ${minBp('tablet')} {
    display: flex;
    flex-direction: row-reverse;
    margin-bottom: 40px;
  }
`;

export const MapOuter = styled.div`
  height: 200px;
  position: relative;
  margin: 0 0 10px;

  @media ${minBp('tablet')} {
    width: 100%;
    margin: 0;
    height: 740px;
  }

  @media ${minBp('desktop')} {
    height: 780px;
  }
`;

export const Pin = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -33px 0 0 -15px;
  background: black;
  color: white;
  font-family: ${theme.fonts.dinDemi};
  font-size: 17px;
  padding-top: 3px;
  cursor: pointer;
  position: relative;

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 3px solid black;
    position: absolute;
    bottom: -3px;
  }

  ${({ selected }) => selected ? `
    width: 36px;
    height: 36px;
    background-color: ${theme.colors.primary};
    margin: -40px 0 0 -18px;

    &:after {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid ${theme.colors.primary};
    }
  ` : ``}
`;

export const Results = styled.div`
  @media ${minBp('tablet')} {
    min-width: 392px;
    margin-right: 16px;
  }
`;

export const ResultCard = styled.div`
  ${({ theme, selected }) => `
    margin: 0 0 10px;
    border: 1px solid #e4e5e6;
    background: ${selected ? '#f1f1f1' : 'white'};
    padding: 17px 13px 13px;
    cursor: pointer;
    display: flex;

    &:last-child {
      margin: 0;
    }

    @media ${minBp('tablet')} {
      margin: 0 0 6px;
      padding: 20px;
    }
  `}
`;

export const ResultCardNumber = styled.div`
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
  max-height: 18px;
  font-size: 13px;
  font-family: ${theme.fonts.dinDemi};
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  padding-top: 1px;

  @media ${minBp('desktop')} {
    width: 26px;
    min-width: 26px;
    height: 26px;
    min-height: 26px;
    max-height: 26px;
    font-size: 17px;
    margin-right: 20px;
    padding-top: 3px;
  }

  ${({ selected }) => selected ? `
    background-color: ${theme.colors.primary};
  ` : ``}
`;

export const ResultCardContent = styled.div`
  flex: 1;
`;

export const ResultTitle = styled.h4`
  text-transform: uppercase;
  font-size: 13px;
  margin: 0 0 8px;

  @media ${minBp('desktop')} {
    font-size: 17px;
  }
`;

export const ResultAddress = styled.div`
  color: #000;
  margin-bottom: 5px;
  font-size: 13px;
  line-height: 18px;

  @media ${minBp('desktop')} {
    font-size: 18px;
    line-height: 25px;
  }
`;

export const ResultDistance = styled.div`
  font-size: 13px;

  @media ${minBp('desktop')} {
    font-size: 14px;
  }
`;
